import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { logger } from "../services/logger";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
  mutationCache: new MutationCache({
    onError: logger.error.bind(logger),
  }),
  queryCache: new QueryCache({
    onError: logger.error.bind(logger),
  }),
});

const QueryProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools buttonPosition="bottom-right" />
      {children}
    </QueryClientProvider>
  );
};

const oneMinute = 60_000;
const oneHour = 3_600_000;
const fifteenMinutes = 900_000;

export { fifteenMinutes, oneHour, oneMinute, QueryProvider };
